import React, { FC, useEffect, useState } from 'react';
import RNVideo from 'react-player';
import { VideoComponentProps } from './video_props';

interface State {
  downloading?: boolean;
  uri?: string;
}

const Video: FC<VideoComponentProps> = (props) => {
  const {
    video_data: { vimeo_id, video_url, youtube_id },
    paused,
    onError,
    onProgress,
    ...rest
  } = props;

  const [state, setState] = useState<State>({
    downloading: true,
  });

  useEffect(() => {
    if (vimeo_id) {
      fetch(`https://player.vimeo.com/video/${vimeo_id}/config`)
        .then((res) => res.json())
        .then((res) =>
          setState({
            uri: res.request.files.hls.cdns[res.request.files.hls.default_cdn]
              .url,
          })
        )
        .catch(() => {
          onError?.();
        });
    } else if (video_url && !state.uri) {
      setState({
        uri: video_url,
      });
    } else if (youtube_id && !state.uri) {
      setState({
        uri: `https://www.youtube.com/watch?v=${youtube_id}`,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vimeo_id, video_url]);

  return state.uri ? (
    <RNVideo
      url={state.uri}
      playing={!!paused}
      {...rest}
      controls
      config={{ youtube: { playerVars: { rel: 0, modestbranding: 1 } } }}
    />
  ) : null;
};

export default Video;
